import { render, staticRenderFns } from "./media_recommendation_detail.vue?vue&type=template&id=76be7c30&scoped=true&"
import script from "./media_recommendation_detail.vue?vue&type=script&lang=js&"
export * from "./media_recommendation_detail.vue?vue&type=script&lang=js&"
import style0 from "./media_recommendation_detail.vue?vue&type=style&index=0&id=76be7c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76be7c30",
  null
  
)

export default component.exports